import React from 'react';
import { IMAGE_BASE } from '../../constants/site';
import { ROAD_PAINT_PRODUCTS, SAFETY_PRODUCTS } from '../solutionsData';

const ProductBlock = ({ eyebrow, title, heroImage, items }) => (
  <article className="solutions-products__block">
    <div className="solutions-products__hero">
      <img src={heroImage} alt={title} />
      <div className="solutions-products__hero-overlay" />
      <div className="solutions-products__hero-content">
        <span className="solutions-products__tag">{eyebrow}</span>
        <h3>{title}</h3>
      </div>
    </div>
    <div className="solutions-products__grid">
      {items.map((item) => (
        <div key={item.title} className="solutions-products__card">
          <div className="solutions-products__card-media">
            <img src={item.image} alt={item.title} />
          </div>
          <p>{item.title}</p>
        </div>
      ))}
    </div>
  </article>
);

const SolutionsProducts = () => (
  <div className="solutions-products">
    <ProductBlock
      eyebrow="Safety signage"
      title="Safety signs for every environment"
      heroImage={`${IMAGE_BASE}/imge30.png`}
      items={SAFETY_PRODUCTS}
    />
    <ProductBlock
      eyebrow="Road marking"
      title="Professional road paint solutions"
      heroImage={`${IMAGE_BASE}/imge30.jpeg`}
      items={ROAD_PAINT_PRODUCTS}
    />
  </div>
);

export default SolutionsProducts;
